import * as React from 'react';
import { Flex } from '@chakra-ui/react';
import { Image, SectionImage } from './SectionImage';
import { SectionText } from './SectionText';

export type BenefitDetails = {
  isOrderReversed?: boolean;
  heading: string;
  subHeading: string;
  body: string;
  images: [Image] | [Image, Image];
};

type BenefitSectionProps = BenefitDetails;

export const BenefitSection: React.FC<BenefitSectionProps> = ({
  isOrderReversed,
  heading,
  subHeading,
  body,
  images,
}) => (
  <Flex
    direction={{
      base: 'column',
      lg: isOrderReversed ? 'row-reverse' : 'row',
    }}
    justify="space-around"
    align="center"
    px={{ base: 0, xl: '130px' }}
  >
    <SectionImage images={images} />
    <SectionText heading={heading} subHeading={subHeading} body={body} />
  </Flex>
);
